import api from "@/services/api";
const prefixed = api;
const methods = prefixed.getPrefixedMethods("mission-control");
export const missionControlService = {
    patients(params, signal) {
        return methods.get("patients", { params, signal });
    },
    counts(signal) {
        return methods.get("counts", { signal });
    },
    recent() {
        return methods.get("recent");
    },
    patient(id, signal) {
        return methods.get(`patients/${id}`, { signal });
    },
    journey(id, historyPage = 1, signal) {
        return methods.get(`patients/${id}/journey`, { params: { history_page: historyPage }, signal });
    },
    documents(id, page = 1) {
        return methods.get(`patients/${id}/documents`, { params: { page } });
    },
    notes(id, page = 1) {
        return methods.get(`patients/${id}/notes`, { params: { page } });
    },
    recordView(id) {
        return methods.post(`patients/${id}/views`);
    },
};
